<template>
  <esg-base-dashboard-card title="온실가스 배출 비율"
                           subtitle="(제품군 - 생애주기별)">
    <template #actions>
      <esg-base-select-box :options="yearOptions"
                           label="연도"
                           size="sm"
                           v-model="year"/>
    </template>
    <firmwide-emission-by-product-family stack-type="100%"
                                         :year="year"/>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import FirmwideEmissionByProductFamily from "../charts2/FirmwideEmissionByProductFamily.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  components: {EsgBaseSelectBox, FirmwideEmissionByProductFamily, EsgBaseDashboardCard},
  created() {
    this.year = this.currentYear;
    this.yearOptions = [this.year , this.year - 1, this.year - 2].map(y => ({text: y, value: y}));
  },
  data() {
    return {
      year: null,
      yearOptions: []
    }
  }
}
</script>
